<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import LoadingHandler from '@/layout/loading/LoadingHandler.vue'
import { productBus } from '@/event/product/productBus'
import { showSelectedModalProductHappy } from '@/happyTheme/event/product/showSelectedModalProductHappy'

const HeaderHappy = defineAsyncComponent(
    () => import('@/happyTheme/components/layout/header/HeaderHappy.vue')
)
const FooterHappy = defineAsyncComponent(
    () => import('@/happyTheme/components/layout/FooterHappy.vue')
)
</script>

<template>
    <section class="w-full relative">
        <div class="w-full min-h-full flex flex-col items-center">
            <section class="w-full z'10">
                <HeaderHappy />
                <div class="h-[60px]"></div>
            </section>

            <LoadingHandler />

            <FooterHappy />
        </div>
    </section>
</template>

<style scoped></style>
